var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pa-4" },
    [
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          "footer-props": { itemsPerPageOptions: [10, 25] },
          items: _vm.adminUsers,
          options: _vm.options,
          "server-items-length": _vm.totalUsers,
          loading: _vm.loading,
          "loading-text": "Loading... Please wait",
        },
        on: {
          "update:options": function ($event) {
            _vm.options = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "footer.page-text",
            fn: function (props) {
              return [
                _vm._v(
                  " " +
                    _vm._s(props.pageStart) +
                    "-" +
                    _vm._s(props.pageStop) +
                    " "
                ),
              ]
            },
          },
          {
            key: "item.Email",
            fn: function ({ item }) {
              return [
                _c("span", { staticClass: "ml-10 ml-md-0" }, [
                  _vm._v(_vm._s(_vm.getEmail(item))),
                ]),
              ]
            },
          },
          {
            key: "footer.prepend",
            fn: function () {
              return [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        _vm.createNewFlightPathAdminDialog = true
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("create_new_fp_admin")) + " ")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px", persistent: "" },
          model: {
            value: _vm.createNewFlightPathAdminDialog,
            callback: function ($$v) {
              _vm.createNewFlightPathAdminDialog = $$v
            },
            expression: "createNewFlightPathAdminDialog",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(" Create New FlightPath Admin"),
              ]),
              _c(
                "v-form",
                {
                  staticClass: "pa-5",
                  model: {
                    value: _vm.newFlightPathAdminFormValid,
                    callback: function ($$v) {
                      _vm.newFlightPathAdminFormValid = $$v
                    },
                    expression: "newFlightPathAdminFormValid",
                  },
                },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      label: "Email",
                      rules: [
                        () => !!_vm.newFlightPathAdminEmail || "Required",
                      ],
                    },
                    model: {
                      value: _vm.newFlightPathAdminEmail,
                      callback: function ($$v) {
                        _vm.newFlightPathAdminEmail = $$v
                      },
                      expression: "newFlightPathAdminEmail",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.createNewFlightPathAdminDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        text: "",
                        disabled: !_vm.newFlightPathAdminFormValid,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.createNewFlightPathAdmin()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("save")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        {
          attrs: { opacity: 0.5, value: _vm.creatingAccount, "z-index": "300" },
        },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "42" },
          }),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { color: "primary", text: "" },
                        on: {
                          click: function ($event) {
                            _vm.snackBar = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Close ")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.snackBar,
            callback: function ($$v) {
              _vm.snackBar = $$v
            },
            expression: "snackBar",
          },
        },
        [_vm._v(" " + _vm._s(_vm.snackBarText) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }